import { appConfig } from "../config/appConfig.js";

/**
 * Optional remote blocklist sync. Returns null when not configured (on-device only).
 */
function getApiBaseUrl() {
  const raw = appConfig.blocklistApiUrl;
  if (!raw) return null;
  return raw.replace(/\/$/, "");
}

export function isBlocklistApiConfigured() {
  return !!getApiBaseUrl();
}

async function jsonFetch(path, options = {}, userId) {
  const base = getApiBaseUrl();
  if (!base) {
    throw new Error("Blocklist API is not configured");
  }
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (userId) {
    headers["x-user-id"] = userId;
  }
  const response = await fetch(`${base}${path}`, { ...options, headers });
  const text = await response.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    /* ignore */
  }
  if (!response.ok) {
    const msg = data?.error || data?.message || text || `HTTP ${response.status}`;
    throw new Error(msg);
  }
  return data;
}

/**
 * @param {string} userId
 * @returns {Promise<string[]>}
 */
export async function loadServerBlocklist(userId) {
  const data = await jsonFetch("/blocklist", { method: "GET" }, userId);
  return Array.isArray(data?.domains) ? data.domains : [];
}

/**
 * @param {string} userId
 * @param {string[]} domains
 */
export async function saveServerBlocklist(userId, domains) {
  return jsonFetch(
    "/blocklist",
    {
      method: "POST",
      body: JSON.stringify({ domains: Array.isArray(domains) ? domains : [] }),
    },
    userId,
  );
}
